import type { ClaimAction, ClaimStatus, OwnershipClaim } from '@/client/types/ownership-claims';

export const CLAIM_STATUS_BADGE: Record<ClaimStatus, string> = {
  pending: 'bg-amber-100 text-amber-800',
  approved: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
  removed: 'bg-gray-200 text-gray-700',
};

export const personLabel = (p?: { uid?: number; name?: string | null; email?: string | null } | null) =>
  p ? p.name || p.email || `uid ${p.uid}` : '—';

/** Actions that make sense for a claim in its current state (the API enforces the same). */
export const availableActions = (claim: OwnershipClaim): ClaimAction[] => {
  switch (claim.status) {
    case 'pending':
      return ['approve', 'reject', 'remove'];
    case 'approved':
    case 'rejected':
      return ['reopen', 'remove'];
    default:
      return [];
  }
};
